import HttpClient from '@/services/http-client'

class ServiceStatusesApi extends HttpClient {
  async list() {
    return (await this.http.get('/v1/service-statuses')).data
  }
}
export default () => new ServiceStatusesApi()
